import {useUtil} from "../../../../util/hooks/useUtil";
import {useAppDispatch, useListFilterValues} from "../../../../hooks/hooks";
import {useCallback, useEffect, useMemo, useState} from "react";
import {
    DEFAULT_PAGE,
    DEFAULT_SIZE,
    DEFAULT_SORT,
    ordersToSortArr,
    PageResponse,
    PageSearchCondition
} from "../../../../types/page";
import {OrganShareDTO, OrganShareListQueryType, OrganShareSearchCondition} from "../../../../types/organShare";
import {getOrganShareListAsync} from "../../../../store/organShareSlice";
import {DEFAULT_PAGE_RESPONSE} from "../../../../util/etcUtil";
import {useSortParam} from "../../../../hooks/list/useSortParam";

export function useOrganShareGetter() {
    const {defaultErrorMessage} = useUtil();
    const dispatch = useAppDispatch();
    const [totalOrganCount, setTotalOrganCount] = useState<number | null>(null)
    const [organShareList, setOrganShareList] =
        useState<PageResponse<OrganShareDTO>>(DEFAULT_PAGE_RESPONSE)

    const {filterValues, searchList, listQueryType} = useListFilterValues();
    const {toSortArray} = useSortParam();


    // 소속 정보 리스트
    const getOrganShareList = useCallback(
        async (param: OrganShareSearchCondition, isFirstLoad?: boolean) => {
            try {

                const result: PageResponse<OrganShareDTO> = await dispatch(getOrganShareListAsync(param)).unwrap();
                setOrganShareList(result)
                setTotalOrganCount(result.totalElements);

                if (isFirstLoad) {
                    setTotalOrganCount(result.totalElements);
                } else {
                    setOrganShareList(result);
                }

            } catch (e) {
                alert(defaultErrorMessage);
            }
        },
        //eslint-disable-next-line
        []
    );

    const getCounselorListWithParam = useCallback(
        (isFirstLoad?: boolean) => {
            if (isFirstLoad) {
                getOrganShareList({}, true).then();
            }

            const organListQueryType = listQueryType as OrganShareListQueryType;
            getOrganShareList({
                pageCondition: {
                    page: organListQueryType.page ? Number(organListQueryType.page) : DEFAULT_PAGE,
                    size: organListQueryType.size ? Number(organListQueryType.size) : DEFAULT_SIZE,
                    sort: organListQueryType.sort ? toSortArray(organListQueryType.sort) : DEFAULT_SORT,
                },

                query: searchWordFilterValue.value ? searchWordFilterValue.value.trim() : undefined,
                query_type: searchWordTypeFilterValue.value,
            }).then();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [listQueryType]);

    const {
        searchWordTypeFilterValue,
        searchWordFilterValue,
        isCheckedFilterValue,
    } = filterValues;

    const searchOrganShareList = (pageSearchCondition: PageSearchCondition) => {
        const param: OrganShareListQueryType = {
            searchWordType: searchWordTypeFilterValue.value,
            searchWord: searchWordFilterValue.value ? searchWordFilterValue.value.trim() : undefined,
        };

        return () => {
            searchList(pageSearchCondition, param)();
        }
    };

    useEffect(() => {
        if (listQueryType) {
            getCounselorListWithParam();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getCounselorListWithParam]);

    // page condition
    const pageCondition = useMemo(
        () => ({
            page: organShareList?.number ?? DEFAULT_PAGE,
            size: organShareList?.size ?? DEFAULT_SIZE,
            sort: ordersToSortArr(organShareList?.orders),
        }),
        [organShareList]
    );

    return{
        organShareList,
        pageCondition,
        totalOrganCount,
        searchOrganShareList,
        getOrganShareList,
        isChecked: isCheckedFilterValue.value
    }
}